function BookingCancelDataView(props) {
  return (
    <tbody>
      <tr>
        <td style={{ width: "20%" }}>{props.CARRIER}</td>

        <td>{props.GENERAL_DAYS}</td>
        <td>{props.REEFER_DAYS}</td>
        <td>{props.DG_DAYS}</td>
      </tr>
    </tbody>
  );
}

export default BookingCancelDataView;
